/**
 * Admin API
 * Admin REST API
 *
 * OpenAPI spec version: 1.0
 * Contact: ti@b4agroup.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface SkeeloDashboardMetricsDTO {
  cancelledCount?: number;
  cancelledThisMonthCount?: number;
  cancelledThisWeekCount?: number;
  cancelledTodayCount?: number;
  thisMonthCount?: number;
  thisWeekCount?: number;
  todayCount?: number;
  totalActiveCount?: number;
}
